import React, { useState } from "react";
import { C } from "../theme";
import { fmt, fmtD, Tag, Btn, Inp } from "../shared";
import { IMMEUBLES, CODES_RESIDENCE } from "../data";

export const ResidentsPage = ({ residents, setResidents, pendingResidents, setPendingResidents, immId }) => {
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(false);
  const [tab, setTab] = useState("actifs");
  const [form, setForm] = useState({nom:"",prenom:"",email:"",pass:"1234",tel:"",apt:"",tantiemes:""});
  const imm = IMMEUBLES.find(i => i.id === immId);
  const list = residents.filter(r => r.immId === immId && `${r.nom} ${r.prenom} ${r.apt}`.toLowerCase().includes(search.toLowerCase()));
  const pending = pendingResidents.filter(r => r.immId === immId);

  const save = () => {
    setResidents(p => [...p, {id:Date.now(), immId, ...form, tantiemes:Number(form.tantiemes), solde:0, statut:"OK"}]);
    setModal(false);
    setForm({nom:"",prenom:"",email:"",pass:"1234",tel:"",apt:"",tantiemes:""});
  };

  const approveResident = (req) => {
    setResidents(p => [...p, {
      id: Date.now(), immId: req.immId,
      nom: req.nom, prenom: req.prenom, email: req.email, pass: req.pass,
      tel: req.tel, apt: req.apt, tantiemes: 0, solde: 0, statut: "OK",
    }]);
    setPendingResidents(p => p.filter(x => x.id !== req.id));
    alert(`✅ ${req.prenom} ${req.nom} approuvé(e) ! Un email de confirmation lui a été envoyé.`);
  };

  const rejectResident = (id) => {
    setPendingResidents(p => p.filter(x => x.id !== id));
    alert("❌ Demande refusée. Le copropriétaire en sera informé par email.");
  };

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}>
        <div>
          <h2 style={{fontSize:24,fontWeight:800,color:C.text}}>Copropriétaires</h2>
          <p style={{color:C.muted,fontSize:13}}>{imm?.nom} · {list.length} résidents</p>
        </div>
        <div style={{display:"flex",gap:12}}>
          <input placeholder="🔍 Rechercher..." value={search} onChange={e => setSearch(e.target.value)}
            style={{padding:"9px 15px",borderRadius:10,border:`1.5px solid ${C.border}`,fontFamily:"DM Sans",fontSize:13,outline:"none",width:200}} />
          <Btn onClick={() => setModal(true)}>+ Ajouter manuellement</Btn>
        </div>
      </div>

      {/* Tabs */}
      <div style={{display:"flex",gap:6,marginBottom:20,background:C.card,padding:5,borderRadius:12,width:"fit-content",boxShadow:"0 2px 10px rgba(11,19,51,.05)"}}>
        <button className="btn" onClick={() => setTab("actifs")}
          style={{padding:"7px 18px",borderRadius:9,fontSize:13,fontWeight:600,
            background:tab==="actifs"?C.teal:"transparent",color:tab==="actifs"?"#fff":C.muted}}>
          👥 Actifs ({list.length})
        </button>
        <button className="btn" onClick={() => setTab("demandes")}
          style={{padding:"7px 18px",borderRadius:9,fontSize:13,fontWeight:600,
            background:tab==="demandes"?C.teal:"transparent",color:tab==="demandes"?"#fff":C.muted,
            display:"flex",alignItems:"center",gap:6}}>
          ⏳ Demandes
          {pending.length > 0 && (
            <span style={{background:C.red,color:"#fff",borderRadius:"50%",width:18,height:18,display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700}}>
              {pending.length}
            </span>
          )}
        </button>
        <button className="btn" onClick={() => setTab("codes")}
          style={{padding:"7px 18px",borderRadius:9,fontSize:13,fontWeight:600,
            background:tab==="codes"?C.teal:"transparent",color:tab==="codes"?"#fff":C.muted}}>
          🔑 Codes d'accès
        </button>
      </div>

      {/* Tab actifs */}
      {tab === "actifs" && (
        <div className="fu" style={{background:C.card,borderRadius:16,boxShadow:"0 2px 14px rgba(11,19,51,.06)",overflow:"hidden"}}>
          <table>
            <thead><tr><th>Copropriétaire</th><th>Appartement</th><th>Tantièmes</th><th>Contact</th><th>Accès portail</th><th>Solde</th><th>Statut</th><th></th></tr></thead>
            <tbody>
              {list.map(r => (
                <tr key={r.id}>
                  <td><div style={{fontWeight:600,color:C.text}}>{r.prenom} {r.nom}</div><div style={{fontSize:12,color:C.muted}}>{r.email}</div></td>
                  <td><span style={{background:C.blueL,color:C.blue,padding:"3px 9px",borderRadius:8,fontSize:12,fontWeight:600}}>{r.apt}</span></td>
                  <td style={{fontWeight:600}}>{r.tantiemes}</td>
                  <td style={{fontSize:12,color:C.muted}}>{r.tel}</td>
                  <td><span style={{background:"#d1fae5",color:"#065f46",padding:"2px 8px",borderRadius:8,fontSize:11,fontWeight:600}}>✓ Actif</span></td>
                  <td style={{fontWeight:700,color:r.solde<0?C.red:r.solde>0?C.green:C.muted}}>{fmt(r.solde)}</td>
                  <td><Tag s={r.statut} /></td>
                  <td><button onClick={() => setResidents(p => p.filter(x => x.id !== r.id))} style={{background:"none",border:"none",cursor:"pointer",color:C.muted,fontSize:17}}>🗑️</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Tab demandes */}
      {tab === "demandes" && (
        <div className="fi">
          {pending.length === 0 ? (
            <div style={{background:C.card,borderRadius:16,padding:48,textAlign:"center",boxShadow:"0 2px 14px rgba(11,19,51,.06)"}}>
              <p style={{fontSize:36,marginBottom:10}}>📭</p>
              <p style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:5}}>Aucune demande en attente</p>
              <p style={{fontSize:13,color:C.muted}}>Les nouvelles inscriptions apparaîtront ici pour validation.</p>
            </div>
          ) : (
            <div style={{display:"flex",flexDirection:"column",gap:14}}>
              {pending.map(req => (
                <div key={req.id} className="fu" style={{background:C.card,borderRadius:16,padding:22,boxShadow:"0 2px 14px rgba(11,19,51,.06)",border:`1.5px solid ${C.border}`}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                    <div style={{display:"flex",alignItems:"center",gap:16}}>
                      <div style={{width:52,height:52,borderRadius:14,background:`linear-gradient(135deg,${C.teal}33,${C.blue}22)`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,fontWeight:700,color:C.teal,fontFamily:"Syne"}}>
                        {req.prenom[0]}{req.nom[0]}
                      </div>
                      <div>
                        <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
                          <h3 style={{fontSize:16,fontWeight:800,color:C.text}}>{req.prenom} {req.nom}</h3>
                          <span style={{background:"#fff3cd",color:"#92400e",padding:"2px 9px",borderRadius:20,fontSize:11,fontWeight:700}}>⏳ En attente</span>
                        </div>
                        <div style={{display:"flex",gap:16,fontSize:13,color:C.muted}}>
                          <span>✉️ {req.email}</span>
                          <span>📞 {req.tel || "—"}</span>
                          <span>🏠 Apt. <strong style={{color:C.text}}>{req.apt}</strong></span>
                          <span>📅 Demande {fmtD(req.createdAt)}</span>
                        </div>
                      </div>
                    </div>
                    <div style={{display:"flex",gap:10}}>
                      <button className="btn" onClick={() => rejectResident(req.id)}
                        style={{padding:"9px 18px",borderRadius:10,background:"#fee2e2",color:C.red,fontWeight:600,fontSize:13}}>
                        ✗ Refuser
                      </button>
                      <Btn onClick={() => approveResident(req)}>
                        ✓ Approuver
                      </Btn>
                    </div>
                  </div>
                  <div style={{marginTop:16,display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10}}>
                    {[["Appartement demandé",req.apt],["Résidence",req.immNom],["Email",req.email]].map(([l,v]) => (
                      <div key={l} style={{background:C.bg,borderRadius:10,padding:"10px 14px"}}>
                        <p style={{fontSize:11,color:C.muted,fontWeight:700,marginBottom:3}}>{l}</p>
                        <p style={{fontSize:13,fontWeight:600,color:C.text}}>{v}</p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Tab codes */}
      {tab === "codes" && (
        <div className="fi">
          <div style={{background:C.card,borderRadius:16,padding:24,boxShadow:"0 2px 14px rgba(11,19,51,.06)",marginBottom:16}}>
            <h4 style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:6}}>Codes d'invitation par résidence</h4>
            <p style={{fontSize:13,color:C.muted,marginBottom:20}}>Partagez ces codes avec vos copropriétaires pour qu'ils puissent s'inscrire sur RésiFlow.</p>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {Object.entries(CODES_RESIDENCE).map(([code, info]) => {
                const active = IMMEUBLES.find(i => i.id === info.immId);
                return (
                  <div key={code} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"16px 20px",borderRadius:14,border:`1.5px solid ${C.border}`,background:info.immId===immId?C.tealL:"#fafbff"}}>
                    <div style={{display:"flex",alignItems:"center",gap:14}}>
                      <div style={{width:42,height:42,borderRadius:12,background:info.immId===immId?`${C.teal}22`:C.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20}}>🏢</div>
                      <div>
                        <p style={{fontWeight:700,color:C.text,fontSize:14}}>{info.nom}</p>
                        <p style={{fontSize:12,color:C.muted}}>{active?.adresse}</p>
                      </div>
                    </div>
                    <div style={{display:"flex",alignItems:"center",gap:12}}>
                      <div style={{background:C.navy,borderRadius:10,padding:"8px 18px"}}>
                        <span style={{fontFamily:"monospace",fontSize:16,fontWeight:700,color:C.teal,letterSpacing:"2px"}}>{code}</span>
                      </div>
                      <button className="btn" onClick={() => {navigator.clipboard?.writeText(code); alert(`Code ${code} copié !`);}}
                        style={{padding:"8px 14px",borderRadius:10,background:C.blueL,color:C.blue,fontWeight:600,fontSize:12}}>
                        📋 Copier
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div style={{background:`linear-gradient(135deg,${C.navy},#1a2b7a)`,borderRadius:16,padding:22,color:"#fff"}}>
            <h4 style={{fontSize:14,fontWeight:700,marginBottom:10}}>💡 Comment inviter un copropriétaire ?</h4>
            {["Partagez le code de résidence par SMS, email ou affiche dans le hall","Le copropriétaire clique sur 'S'inscrire' sur la page de connexion RésiFlow","Il entre le code, remplit ses informations et soumet sa demande","Vous recevez une notification et approuvez sa demande ici","Le copropriétaire reçoit un email et peut se connecter immédiatement"].map((s,i) => (
              <div key={i} style={{display:"flex",alignItems:"flex-start",gap:10,marginBottom:8}}>
                <span style={{width:20,height:20,borderRadius:"50%",background:C.teal,color:"#fff",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,flexShrink:0}}>{i+1}</span>
                <p style={{fontSize:13,color:"rgba(255,255,255,.6)",lineHeight:1.5}}>{s}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Modal ajout manuel */}
      {modal && (
        <div className="ov" onClick={() => setModal(false)}>
          <div className="mb" onClick={e => e.stopPropagation()}>
            <h3 style={{fontSize:19,fontWeight:800,color:C.text,marginBottom:8}}>Ajouter manuellement</h3>
            <p style={{fontSize:13,color:C.muted,marginBottom:18,background:C.tealL,padding:"9px 14px",borderRadius:10}}>
              💡 L'email sera l'identifiant du copropriétaire pour se connecter au portail.
            </p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
              <Inp label="Nom" value={form.nom} onChange={v => setForm({...form,nom:v})} />
              <Inp label="Prénom" value={form.prenom} onChange={v => setForm({...form,prenom:v})} />
            </div>
            <Inp label="Email" type="email" value={form.email} onChange={v => setForm({...form,email:v})} />
            <Inp label="Mot de passe" value={form.pass} onChange={v => setForm({...form,pass:v})} />
            <Inp label="Téléphone" value={form.tel} onChange={v => setForm({...form,tel:v})} />
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
              <Inp label="Appartement" value={form.apt} onChange={v => setForm({...form,apt:v})} placeholder="A101" />
              <Inp label="Tantièmes" type="number" value={form.tantiemes} onChange={v => setForm({...form,tantiemes:v})} />
            </div>
            <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
              <Btn onClick={() => setModal(false)} outline>Annuler</Btn>
              <Btn onClick={save}>Enregistrer</Btn>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

/* ══════════════════════════════════════
   SYNDIC — COTISATIONS
══════════════════════════════════════ */
